export const DEFAULT_DURATION = 200;
export const DEFAULT_TIMING_FUNCTION = 'ease-out';

export function animate(
  target: Element,
  keyframes: Keyframe[] | PropertyIndexedKeyframes,
  { duration = DEFAULT_DURATION, easing = DEFAULT_TIMING_FUNCTION, ...options }: KeyframeAnimationOptions = {},
) {
  return target.animate(keyframes, {
    duration,
    easing,
    ...options,
  });
}
